import React, {useCallback, useEffect} from 'react';
import {useAppDispatch, useAppSelector} from "../app/hooks";
import {Button, Divider, Image, Tag, Typography} from "antd";
import {selectKichi, selectKichiId, setDirection, setMode} from "../features/omikuji/omikujiSlice";
import {LoadingOutlined, TwitterOutlined} from "@ant-design/icons";
import Link from "antd/es/typography/Link";
import md5 from "md5";

export function Screen9_Result(props: any) {
    const dispatch = useAppDispatch();
    const kichi = useAppSelector(selectKichi)
    const kichiId = useAppSelector(selectKichiId)
    const kichiMd5 = useCallback((kichi: string) => {
        const hashseed = `${kichi}-2023-elithgogo`
        const imagemd5 = md5(hashseed)
        return imagemd5
    }, [kichi])
    const kichiImage = useCallback((kichi: string) => {
        const hashseed = `${kichi}-2023-elithgogo`
        const imagemd5 = md5(hashseed)
        return `https://aiomikuji2023image.s3.ap-northeast-1.amazonaws.com/${imagemd5}.png`
    }, [kichi])
    const kichiTweetUrl = useCallback((kichi: string | undefined) => {
        if (kichi === undefined) {
            return `http://twitter.com/intent/tweet?text=AIおみくじ&url=https://ai-omikuji2023.elith.co.jp&via=aiomikuji&related=aiomikuji&hashtags=AIおみくじ`
        } else {
            const img = kichiImage(kichi)
            // return `http://twitter.com/intent/tweet?text=AIおみくじで${kichi}吉！！&url=https://ai-omikuji2023.elith.co.jp?r=${kichiMd5(kichi)}&via=aiomikuji&related=aiomikuji&hashtags=AIおみくじ`
            return `http://twitter.com/intent/tweet?text=AIおみくじで${kichi}吉！！&url=https://ai-omikuji2023.elith.co.jp&via=aiomikuji&hashtags=AIおみくじ`
        }
    }, [kichi])
    useEffect(() => {
        // if (!clapSound) return
        // console.log(clapSound)
        // var snd = new Audio(clapSound);
        // // var snd = new Audio("data:audio/wav;base64," + clapSound);
        // snd.play();
    }, [])
    return <>
        {kichi === undefined && <p><LoadingOutlined/>吉！！！！！</p>}
        {kichi !== undefined && <>
            <Image src={kichiImage(kichi)} preview={false} style={{width: "70%"}}/>
            <Typography.Paragraph>
                <p>{kichi}吉！！！！！</p>
            </Typography.Paragraph>
        </>
        }
        {/*<p>AIが算出したあなたの２拍手と<br/>理想的な２拍手との距離は<br/><code>0.100557411</code>でした</p>*/}
        {/*<p>10000吉は今年410/24000位の運勢です</p>*/}
        {/*<p>今年も楽しくね！</p>*/}
        <p>
            <Link href={kichiTweetUrl(kichi)}>
                <Tag style={{cursor: "pointer"}} icon={<TwitterOutlined/>} color="#55acee">
                    結果をTweetする！
                </Tag>
            </Link>
            <br/>
            ※画像をスクリーンショットしてtweetしてね
            {/*<p>{kichiId}</p>*/}
        </p>
        <Divider/>
        <Button onClick={() => {
            dispatch(setMode("mode2_Top"))
            dispatch(setDirection(undefined))
        }}>もう一度おみくじを引く</Button>
        <p>最高値の「2023吉」を目指そう！</p>
        <Divider/>
        <p>
            AIおみくじの仕組み
        </p>
        <p>
            <Link href="https://elith.co.jp/demo/ai-omikuji2023" target="_blank">AIおみくじ2023 技術解説</Link>
        </p>
    </>
}
